import { storeToRefs } from 'pinia';
import { defineComponent, ref, computed } from 'vue';
import LoaderComponent from '@/components/general/LoaderComponent.vue';
import en from '@/locale/en.locale';
import useTransactionsStore from '@/store/modules/transactions';
import { useAuthStore } from '@/store/modules/auth';
import { useKycStore } from '@/store/modules/kyc';
import { usePayoutAccountsStore } from '@/store/modules/payout-accounts';
import router, { RoutePaths } from '@/router';
import { logoutUser } from '@/utils/logout';
import { MIXPANEL_EVENTS, trackEvent } from '@/utils/mixpanel';
import { KycTypes } from '@/types/kyc';
import { TransactTypes } from '@/types/transact';
var TransactSteps = TransactTypes.TransactSteps;
export default defineComponent({
    name: 'SideMenu',
    components: { LoaderComponent },
    setup() {
        const transactionsStore = useTransactionsStore();
        const authStore = useAuthStore();
        const kycStore = useKycStore();
        const { currentStep: kycStep } = storeToRefs(kycStore);
        const { showSideMenu, loadingMessage, currentStep: transactStep, } = storeToRefs(transactionsStore);
        const { isLoggedIn, partnerId } = storeToRefs(authStore);
        const payoutAccountsStore = usePayoutAccountsStore();
        const { fromTransaction } = storeToRefs(payoutAccountsStore);
        const loading = ref(false);
        const onKeyPress = (event) => {
            event.preventDefault();
        };
        const closeMenu = (event) => {
            event.stopImmediatePropagation();
            showSideMenu.value = false;
        };
        const menuContainerClick = (event) => {
            event.stopImmediatePropagation();
        };
        const viewPrivacyPolicy = (event) => {
            event.stopImmediatePropagation();
            window.open(en.home.menu.privacyLink, '_blank');
        };
        const viewTermsOfUse = (event) => {
            event.stopImmediatePropagation();
            window.open(en.home.menu.tosLink, '_blank');
        };
        const contactSupport = (event) => {
            event.stopImmediatePropagation();
            window.open(en.home.menu.supportLink, '_blank');
        };
        const logout = async () => {
            loading.value = true;
            loadingMessage.value = 'Signing out';
            await authStore.Logout();
            logoutUser();
            transactStep.value = TransactSteps.BUY_1;
            await router.push(RoutePaths.Transact);
            loading.value = false;
            loadingMessage.value = '';
            showSideMenu.value = false;
        };
        const viewProfile = () => {
            showSideMenu.value = false;
            router.push(RoutePaths.Profile);
        };
        const viewVerificationStatus = () => {
            trackEvent(MIXPANEL_EVENTS.KYC.CHECK_STATUS, {
                screen: 'Home Screen',
                partner: partnerId.value,
            });
            showSideMenu.value = false;
            kycStep.value = KycTypes.KycSteps.VERIFICATION_STATUS;
            router.push(RoutePaths.Kyc);
        };
        const viewPayoutAccounts = () => {
            showSideMenu.value = false;
            fromTransaction.value = false;
            router.push(RoutePaths.PayoutAccounts);
        };
        const menuItems = computed(() => [
            {
                title: 'home.menu.profile',
                condition: isLoggedIn.value,
                keypress: onKeyPress,
                click: viewProfile,
                imgSrc: require('@/assets/ProfileOutline.svg'),
                imgAlt: 'profile',
            },
            {
                title: 'home.menu.payoutAccounts',
                condition: isLoggedIn.value,
                keypress: onKeyPress,
                click: viewPayoutAccounts,
                imgSrc: require('@/assets/Wallet.svg'),
                imgAlt: 'wallet',
            },
            {
                title: 'home.menu.verificationStatus',
                condition: isLoggedIn.value,
                keypress: onKeyPress,
                click: viewVerificationStatus,
                imgSrc: require('@/assets/Verification.svg'),
                imgAlt: 'verification',
            },
            {
                title: 'home.menu.tos',
                condition: true,
                keypress: onKeyPress,
                click: viewTermsOfUse,
                imgSrc: require('@/assets/Tos.svg'),
                imgAlt: 'tos',
            },
            {
                title: 'home.menu.privacy',
                condition: true,
                keypress: onKeyPress,
                click: viewPrivacyPolicy,
                imgSrc: require('@/assets/Privacy.svg'),
                imgAlt: 'privacy',
            },
            {
                title: 'home.menu.support',
                condition: true,
                keypress: onKeyPress,
                click: contactSupport,
                imgSrc: require('@/assets/Support.svg'),
                imgAlt: 'support',
            },
        ]);
        return {
            onKeyPress,
            closeMenu,
            isLoggedIn,
            viewProfile,
            viewVerificationStatus,
            logout,
            loading,
            menuContainerClick,
            viewPrivacyPolicy,
            viewTermsOfUse,
            menuItems,
        };
    },
});
